import { EmployeeService } from './../../features/employees/employee.service';
// import { InventoryItemService } from './../../features/inventory/services/inventory.service';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { QuotationService } from '../../features/quotation/services/quotation.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { UploadFileService } from '../../shared/services/file-upload.service';
import { InvoiceService } from '../../features/invoice/services/invoice.service';
import { MatDialog } from '@angular/material/dialog';
import {
  Subject,
  Subscription,
  debounceTime,
  distinctUntilChanged,
} from 'rxjs';
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import {
  maxDiscountValidator,
  nonNegativeValidator,
  rateValidator,
  trnValidator,
} from '../../shared/services/validations';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { PartnerTypesEnum, UNITTYPES } from '../../helpers/helper-file';
import { AuthService } from '../../core/services/auth.service';
import { CustomerService } from '../../features/customers/services/customer.service';
import { ServiceManagementService } from '../../features/service-management/services/service-management.service';
import { AddItemsDialog } from './add-items.component';
import { LeadService } from '../../features/leads/services/lead.service';
import { PreferenceCodeService } from '../../features/preference-code/services/preference-code.service';

@Component({
  selector: 'app-quotation-new',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatAutocompleteModule,
    RouterModule
  ],
  templateUrl: './quotation-new.component.html',
  styleUrl: './quotation-new.component.scss',
})
export class QuotationNewComponent implements OnInit {
  public arr = [1, 2, 3, 4, 5, 6, 7];
  public isEditMode = false;
  filter: {} = {};
  search: string = '';
  loading: boolean = false;
  quoteForm: FormGroup;
  workSplitForm: FormGroup;
  quoteData: any;
  quoteId: number | null = null;
  TRNNumber: number | null = null;
  subTotalValue: number;
  selectedBranchId: number;
  addedItems: any[] = [];
  isBranchReadOnly: boolean = false;
  quoteItemLength: number;
  private partnerTypes = PartnerTypesEnum;
  public selectedBillingAddress: any = {};
  public selectedShippingAddress: any = {};
  public billingAddressList: any[];
  public shippingAddressList: any[];
  public partnersData: any[] = [];
  public itemData: any[] = [];
  private searchSubject = new Subject<string>();
  public projectData: any[] = [];
  public leadData: any[] = [];
  public serviceData: any[] = [];
  private projectSearchSubject = new Subject<string>();
  public branchData: any[] = [];
  private branchSearchSubject = new Subject<string>();
  selectedCustomerId: any;
  public filteredItemData: any[] = [];
  readonly dialog = inject(MatDialog);
  private isUpdating: boolean = false;
  calculatedItems: any[] = [];
  loadedQuoteStatus: any;
  loadedParentQuoteId: number;
  loadedBranchId: number;

  file: any = null;
  csvFile: File[] = [];
  url: string = '';
  fileDetailsArray: {
    // fileName: string;
    // fileName: string;
    fileUrl: string;
    id?: number;
    // isNew: boolean;
  }[] = [];
  unitTypes: any = UNITTYPES;
  leadId: any;

  @ViewChild('fileInput') fileInput!: ElementRef;
  currentFiles: File[] = [];
  private status: 'Draft' | 'Pending' = 'Draft';
  prefix: any;
  quoteNumber: any;
  discount: any = 0;
  hasShownWarning: boolean = false;
  finalizeQuote: boolean = false;
  revisionQuote: boolean = false;
  variationQuote: boolean = false;
  serviceTasksMap: { [serviceId: number]: any[] } = {};

  constructor(
    private quoteService: QuotationService,
    private serviceManagementService: ServiceManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private leadService: LeadService,
    private documentUploadService: UploadFileService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private employeeService: EmployeeService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private datePipe: DatePipe,
    private preferenceService: PreferenceCodeService  
  ) {}

  ngOnInit(): void {
    this.selectedBranchId = this.authService.getSelectedBranchId();

    if (this.selectedBranchId == 0 || !this.selectedBranchId) {
      this.isBranchReadOnly = false;
    } else {
      this.isBranchReadOnly = true;
    }

    this.route.queryParamMap.subscribe((params) => {
      this.leadId = params.get('leadId');
      console.log('this.leadId',this.leadId);
      
      if(this.leadId){
        this.fetchLeadById();
      }
    });

    this.fetchPartners();
    this.getLeadDropdown();
    this.getServices();
    this.initForm();

    this.fetchItems();
    this.generateQuoteNumber();
    this.listBranches();

    this.quoteForm
      .get('discountType')
      ?.valueChanges.subscribe((discountType) => {
        const discount = Number(this.quoteForm.get('discount')?.value || 0);
        const subTotal = Number(this.getSubTotalAmount());

        if (discountType === 'Fixed') {
          this.quoteForm.patchValue({ discountValue: discount.toFixed(2) });
          this.discount = discount.toFixed(2);
        } else if (discountType === 'Percentage') {
          const calculatedDiscount = (discount / 100) * subTotal;
          this.discount = calculatedDiscount;
          this.quoteForm.patchValue({
            discountValue: calculatedDiscount.toFixed(2),
          });
        }
      });

    this.quoteForm
      .get('discount')
      ?.valueChanges.subscribe((discount) => {
        const discountType = this.quoteForm.get('discountType')?.value;
        // const discountValue = this.quoteForm.get('discountValue')?.value;
        const subTotal = Number(this.getSubTotalAmount());

        console.log('discountType',discountType);
        

        if (discountType === 'Fixed') {
          this.quoteForm.patchValue({ discountValue: discount?.toFixed(2) });
          this.discount = discount;
        } else if (discountType === 'Percentage') {
          const calculatedDiscount = (discount / 100) * subTotal;
          this.discount = calculatedDiscount;
          
          this.quoteForm.patchValue({
            discountValue: calculatedDiscount.toFixed(2),
          }); 
        }
      });

    this.items.valueChanges.subscribe(() => {
      this.items.controls.forEach((control, index) => {
        this.updateItemTotal(index);
      });
    });

    this.route.queryParams.subscribe((params) => {
      const finalizeQuote = params['finalizeQuote'];
      const revisionQuote = params['revisionQuote'];
      const variationQuote = params['variationQuote'];
      if (finalizeQuote) {
        this.finalizeQuote = true;
      }
      if (revisionQuote) {
        this.revisionQuote = true;
      }
      if (variationQuote) {
        this.variationQuote = true;
      }
    });
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.quoteId = +id;
        this.isEditMode = true;
        this.quoteForm.get('partnerId')?.disable();
        if (this.partnersData && this.partnersData.length) {
          this.loadQuoteData();
        } else {
          this.fetchPartners();

          setTimeout(() => this.loadQuoteData(), 500);
        }
        this.updateCalculatedItems();
      } else {
        this.preferenceCode();
      }
    });

    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.fetchPartners(searchTerm);
      });

    this.projectSearchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {});

    this.branchSearchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.listBranches(searchTerm);
      });

    this.items.valueChanges.subscribe(() => {
      this.getTotalAmount();
      this.getSubTotalAmount();
    });
    // this.quoteForm.get('discount')?.valueChanges.subscribe((discount) => {
    //   this.discount = discount;
    // });

    if (!this.quoteId) {
      this.addItem();
    }
  }

  initForm(): void {
    this.quoteForm = this.fb.group({
      id: [this.quoteData?.id || ''],
      customerId: [this.quoteData?.customerId, Validators.required],
      leadId: [this.quoteData?.leadId, Validators.required],
      projectName: [this.quoteData?.projectName, Validators.required],
      quoteCode: [this.quoteData?.quoteCode, Validators.required],
      quoteDate: ['', Validators.required],
      validUntil: [''],
      branchId: [
        {
          value: Number(this.selectedBranchId),
          disabled: this.isBranchReadOnly,
        },
        [Validators.required, this.branchValidator],
      ],
      paymentTerms: [this.quoteData?.paymentTerms],
      discount: [this.quoteData?.discount || 0],
      discountValue: [this.quoteData?.discountValue],
      discountType: [this.quoteData?.discountType],
      discountReason: [this.quoteData?.discountReason],
      isPriority: [this.quoteData?.isPriority],
      // approvalDate: [new Date(Number(this.quoteData?.approvalDate)) || new Date()],
      tax: [this.quoteData?.tax],
      notes: [this.quoteData?.notes],
      items: this.fb.array([]),

    });
    this.setupDiscountValidation();
    
    // Listen for changes in quoteDate and update validity field validation
    this.quoteForm.get('quoteDate')?.valueChanges.subscribe(() => {
      this.quoteForm.get('validity')?.updateValueAndValidity();
    });

    // Dynamically adjust validation for branchId
    const branchIdControl = this.quoteForm.get('branchId');
    if (this.selectedBranchId == 0) {
      branchIdControl?.setValidators([
        Validators.required,
        this.branchValidator,
      ]);
    } else {
      branchIdControl?.clearValidators();
    }
    branchIdControl?.updateValueAndValidity();

    branchIdControl?.valueChanges.pipe(debounceTime(300)).subscribe((value) => {
      if (value == 0) {
        branchIdControl.setValidators([
          Validators.required,
          this.branchValidator,
        ]);
      } else {
        branchIdControl.clearValidators();
      }
      branchIdControl.updateValueAndValidity();
    });
  }

  setupDiscountValidation(): void {
    const discountControl = this.quoteForm.get('discount');
    const discountTypeControl = this.quoteForm.get('discountType');
  
    if (discountTypeControl && discountControl) {
      discountTypeControl.valueChanges.subscribe((discountType) => {
        if (discountType === 'Percentage') {
          discountControl?.setValidators(maxDiscountValidator(100));
        } 
        // else {
        //   discountControl?.setValidators(); // Reset to basic validation
        // }
        discountControl?.updateValueAndValidity();
      });
  
      // Initial validation setup based on the current discountType value
      if (discountTypeControl.value === 'Percentage') {
        discountControl?.setValidators(maxDiscountValidator(100));
      } 
      // else {
      //   discountControl?.setValidators();
      // }
      discountControl?.updateValueAndValidity();
    }
  }
  

  branchValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value === 0) {
      return { branchInvalid: true };
    }
    return null;
  }

  validityDateValidator(control: AbstractControl): ValidationErrors | null {
    const quoteDate = control.parent?.get('quoteDate')?.value;
    const validityDate = control.value;

    if (
      quoteDate &&
      validityDate &&
      new Date(validityDate) < new Date(quoteDate)
    ) {
      return { validityDateInvalid: true }; // Return error if validity date is before quote date
    }
    return null;
  }


  onServiceChange(serviceId: number, index: number) {
    const selectedService = this.serviceData.find(service => service.id === serviceId);
    if (selectedService) {
      const totalPrice = selectedService.totalPrice;
      const itemsArray = this.quoteForm.get('items') as FormArray;
      const itemGroup = itemsArray.at(index) as FormGroup;
      itemGroup.get('rate')?.setValue(totalPrice);
      itemGroup.get('unit')?.setValue('nos');
  
      const dialogRef = this.dialog.open(AddItemsDialog, {
        data: {
          serviceId,
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          // Save tasks for this serviceId
          this.serviceTasksMap[serviceId] = res.map((task: any) => ({
            taskVariantId: task.variant.id,
            serviceTaskId: task.serviceTaskId,
            price: task.variant.price,
            estimatedTime: task.variant.estimatedTime
          }));
      
          // Calculate total price and ETA
          let totalVariantPrice = 0;
          let totalVariantEta = 0;
      
          this.serviceTasksMap[serviceId].forEach((task) => {
            totalVariantPrice += task.price || 0;
            totalVariantEta += Number(task.estimatedTime) || 0;
          });
      
          this.items.at(index).patchValue({
            rate: totalVariantPrice || 0,
            eta: totalVariantEta || 0
          });
      
          this.getTotalAmount();
          this.getSubTotalAmount();
        }
      });
      
    }
  }
  
  

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  onProjectSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.projectSearchSubject.next(searchTerm);
  }

  onBranchSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.branchSearchSubject.next(searchTerm);
  }

  onCustomerSelected(event: MatSelectChange): void {
    const selectedCustomerId = event.value;
    this.selectedCustomerId = event.value;
    const selectedPartner = this.partnersData.find(
      (partner) => partner.id === selectedCustomerId
    );

    if (selectedPartner) {
      // Update TRN field with selected partner's TRN number
      if (selectedPartner.trnNumber) {
        this.quoteForm.patchValue({
          TRN: selectedPartner.trnNumber,
        });
      } else {
        this.quoteForm.patchValue({
          TRN: '',
        });
      }
    }
  }

  getLeadDropdown(search?: any): void {
    this.quoteService.leadsDropDown(search, 'ClosedWon').subscribe({
      next: (data) => {
        this.leadData = data;
      },
    });
  }

  getServices(search?: any): void {
    this.serviceManagementService.serviceDropdown(search).subscribe({
      next: (data) => {
        this.serviceData = data;
      },
    });
  }

  private fetchLeadById(): void {
    if (this.leadId !== null) {
      this.leadService.fetchLeadById(Number(this.leadId)).subscribe({

        next: (data) => {
          const leadData = data;
          this.quoteForm.patchValue({
            customerId: Number(leadData.customerId),
            leadId: Number(leadData?.id),
          });
        },
        error: (error) => console.error(error),
      });
    } else {
      console.warn('Journal ID is null; cannot load journal data.');
    }
  }

  loadQuoteData(): void {
    if (this.quoteId !== null) {
      this.quoteService.fetchQuoteById(this.quoteId).subscribe({
        next: (data) => {
          this.quoteData = data?.quote;
          console.log('this.quoteData',this.quoteData?.branchId);
          
          if (this.quoteData) {
            this.updateCalculatedItems();
            this.loadedQuoteStatus = this.quoteData?.status;
            this.loadedParentQuoteId = this.quoteData?.parentQuoteId;
            this.loadedBranchId = this.quoteData?.branchId;
          }

          // After projectData is populated, patch the form
          this.quoteForm.patchValue({
            customerId: this.quoteData.customerId,
            leadId: this.quoteData?.leadId,
            projectName: this.quoteData?.projectName,
            quoteCode: this.quoteData?.quoteCode,
            quoteDate: new Date(Number(this.quoteData?.quoteDate)) || new Date(),
            validUntil: new Date(Number(this.quoteData?.validUntil)) || new Date(),
            // branchId:
            //   this.quoteData?.branchId || this.selectedBranchId,
            paymentTerms: this.quoteData?.paymentTerms,
            discount: this.quoteData?.discount || 0,
            discountValue: this.quoteData?.discountValue,
            discountType: this.quoteData?.discountType,
            discountReason: this.quoteData?.discountReason,
            isPriority: this.quoteData?.isPriority,
            // approvalDate: new Date(Number(this.quoteData?.approvalDate)) || new Date(),
            tax: this.quoteData?.tax,
            notes: this.quoteData?.notes,
          });

          console.log('this.quoteForm',this.quoteForm.value);
          

          this.quoteItemLength = data.quote?.quoteItems.length;

          if (data.quote?.quoteItems) {
            data.quote?.quoteItems.forEach((item: any) => {
              const itemForm = this.fb.group({
                id: [item.id || null],
                serviceId: [item.serviceId, Validators.required],
                quantity: [item.quantity, Validators.required],
                unit: [item.unit, Validators.required],
                rate: [item.rate, Validators.required],
                eta: [item.eta, Validators.required],
                amount: [item.amount, Validators.required],
              });
              // this.items.push(itemForm);
              this.addedItems.push(itemForm);
              this.calculateAmount(itemForm);
            });
          }
        },
      });
    }
  }

  getUpdateQuoteItemInput(): any[] {
    return this.items.controls.map((itemGroup) => {
      const id = itemGroup.get('id')?.value;
      const serviceId = itemGroup.get('serviceId')?.value;
      const quantity = itemGroup.get('quantity')?.value;
      const unit = itemGroup.get('unit')?.value;
      const rate = parseFloat(itemGroup.get('rate')?.value);
      const eta = parseFloat(itemGroup.get('eta')?.value);
      const amount = parseFloat(itemGroup.get('amount')?.value);

      const existingQuoteItem = this.quoteData?.quoteItems?.find(
        (quoteItem: any) => quoteItem.id === id
      );

      return {
        id: existingQuoteItem ? existingQuoteItem.id : null,
        serviceId,
        quantity,
        unit,
        rate,
        eta,
        amount,
      };
    });
  }

  addItem(): void {
    const itemGroup = this.fb.group({
      quantity: [
        '1',
        [
          Validators.required,
          Validators.pattern(/^\d+(\.\d+)?$/),
          nonNegativeValidator,
        ],
      ],
      serviceId: ['', Validators.required],
      unit: ['', Validators.required],
      rate: ['', [Validators.required, nonNegativeValidator, rateValidator]],
      eta: ['', Validators.required],
      amount: [0, [Validators.required, nonNegativeValidator]],
    });

    this.items.push(itemGroup);

    // Trigger validation checks after adding the group
    itemGroup.updateValueAndValidity();
    this.items.updateValueAndValidity();

    itemGroup
      .get('rate')
      ?.valueChanges.subscribe(() => {
        this.calculateAmount(itemGroup);
      });
    itemGroup
      .get('quantity')
      ?.valueChanges.subscribe(() => this.calculateAmount(itemGroup));
    itemGroup
      .get('discount')
      ?.valueChanges.subscribe(() => this.calculateAmount(itemGroup));
  }

  calculateAmount(itemGroup: FormGroup): void {
    const rate = parseFloat(itemGroup.get('rate')?.value || 0);
    const quantity = parseFloat(itemGroup.get('quantity')?.value || '0');
    const discount = itemGroup.get('discount')?.value || 0;
    let grossAmount = rate * quantity;
    if (discount > 0) {
      grossAmount = grossAmount - discount;
    }
    itemGroup.patchValue({ grossAmount });
    const tax = (grossAmount * 0.05).toFixed(2) || 0;
    itemGroup.patchValue({ tax });
    itemGroup.patchValue({ grossAmount });
    let amount = Number(grossAmount) + Number(tax);
    itemGroup.patchValue({ amount });
  }

  getSubTotalAmount(): number {
    const newItemsSubtotal = this.items.controls.reduce((subtotal, item) => {
      const quantity = parseFloat(item.get('quantity')?.value || '0');
      const rate = parseFloat(item.get('rate')?.value || '0');
      return subtotal + quantity * rate;
    }, 0);

    const existingItemsSubtotal = this.quoteData?.quoteItems.reduce(
      (subtotal: any, item: any) => {
        const quantity = parseFloat(item.quantity || '0');
        const rate = parseFloat(item.rate || '0');
        return subtotal + quantity * rate;
      },
      0
    );

    // Return the total subtotal
    return newItemsSubtotal + (existingItemsSubtotal || 0);
  }

  getTotalVat(): number {
    const subTotal: number = Number(this.getSubTotalAmount());
    return subTotal * 0.05;
  }

  getTotalAmount(): number {
    const subTotal = Number(this.getSubTotalAmount());
    const totalDiscount = Number(this.discount);
    const vat = Number(this.getTotalVat());
    return subTotal - totalDiscount + vat;
  }

  updateItemTotal(index: number): void {
    const itemsControl = this.items.controls[index];
    const quantity = itemsControl.get('quantity')?.value || 0;
    const rate = itemsControl.get('rate')?.value || 0;
    const discount = itemsControl.get('discount')?.value || 0;

    const grossAmount = quantity * rate - discount;
    itemsControl
      .get('grossAmount')
      ?.setValue(grossAmount, { emitEvent: false });

    const vatControl = itemsControl.get('tax');
    if (!vatControl?.dirty) {
      const vatValue = +(grossAmount * 0.05).toFixed(2);
      vatControl?.setValue(vatValue, { emitEvent: false });
    } else {
      const userEnteredVat = +vatControl?.value;
      const formattedVat = +userEnteredVat.toFixed(2);
      vatControl?.setValue(formattedVat, { emitEvent: false });
    }
    const vat = vatControl?.value || 0;
    const totalAmount = grossAmount + vat;
    itemsControl.get('amount')?.setValue(totalAmount, { emitEvent: false });

    itemsControl.get('rate')?.valueChanges.subscribe(() => {
      const discount = Number(this.quoteForm.get('discount')?.value || 0);
      const discountType = this.quoteForm.get('discountType')?.value;
      const subTotal = Number(this.getSubTotalAmount());

      if (discountType === 'Fixed') {
        this.quoteForm.patchValue({ discountValue: discount.toFixed(2) });
        this.discount = discount.toFixed(2);
      } else if (discountType === 'Percentage') {
        const calculatedDiscount = (discount / 100) * subTotal;
        this.discount = calculatedDiscount;
        this.quoteForm.patchValue({
          discountValue: calculatedDiscount.toFixed(2),
        });
        
      }
    });
  }

  getItemTotalAmount(item: any): number {
    const quantity = parseFloat(item?.quantity || '0');
    const rate = parseFloat(item?.rate || '0');
    return quantity * rate;
  }

  get items(): FormArray {
    return this.quoteForm.get('items') as FormArray;
  }

  get branches(): FormArray {
    return this.quoteForm.get('branches') as FormArray;
  }


  saveAsDraft(): void {
    this.status = 'Draft';
    this.createQuote('quotation/quotation-details');
  }

  saveAndSend(): void {
    this.status = 'Pending';
    this.createQuote('quotation/quotation-details/mail');
  }

  createQuote(navigateTo: string): void {
    if (this.quoteForm.invalid) {
      this.quoteForm.markAllAsTouched();
      console.log('Form is Invalid',this.quoteForm.controls);
      
      this.toastr.warning('Please fill in all required fields.');
      return;
    }
  
    const formValues = this.quoteForm.value;
    const subTotal = this.getSubTotalAmount().toFixed(2);
    const tax = this.getTotalVat().toFixed(2);
  
    const createQuoteInput = {
      branchId: formValues.branchId,
      customerId: formValues.customerId,
      leadId: formValues.leadId,
      quoteCode: formValues.quoteCode,
      quoteDate: formValues.quoteDate,
      validUntil: formValues.validUntil,
      subTotal: Number(subTotal),
      tax: Number(tax),
      discount: Number(formValues.discount),
      totalAmount: Number(this.getTotalAmount().toFixed(2)),
      quoteStatus: this.status,
      discountValue: Number(formValues.discountValue),
      discountType: formValues.discountType,
      discountReason: formValues.discountReason,
      isDiscountApproved: formValues.isDiscountApproved,
      paymentTerms: formValues.paymentTerms,
      // approvalDate: formValues.approvalDate,
      isPriority: formValues.isPriority,
      projectName: formValues.projectName,
      notes: formValues.notes,
      status: 1,
      ...(this.quoteId ? {} : { version: '1' })
    };
  
    const quoteItemsRaw = this.quoteForm.getRawValue().items;
  
    const quoteItems = quoteItemsRaw.map((item: any) => {
      const quoteItem = {
        quoteId: this.quoteId || null,
        serviceId: item.serviceId,
        quantity: item.quantity,
        unit: item.unit,
        rate: parseFloat(item.rate.toFixed(2)),
        // eta: parseFloat(item.eta.toFixed(2)),
        amount: parseFloat(item.amount.toFixed(2)),
        status: 1
      };
  
      const serviceTasksRaw = this.serviceTasksMap[item.serviceId] || [];
  
      const serviceTasks = serviceTasksRaw.map((task: any) => ({
        // quoteItemId: task.id,
        serviceTaskId: task.serviceTaskId || null,
        taskVariantId: task.taskVariantId,
        price: task.price,
        estimatedTime: task.estimatedTime
      }));
  
      return {
        quoteItem,
        serviceTasks
      };
    });
  
    const payload = {
      createQuoteInput,
      quoteItems
    };
  
    this.loading = true;
  
    if (this.quoteId) {
      // Update existing quote
      this.quoteService.updateQuotation(this.quoteId, createQuoteInput, quoteItems).subscribe({
        next: () => {
          this.toastr.success('Quotation updated successfully.', 'Success');
          this.router.navigate(['/quotation']);
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error.message || 'Failed to update Quotation.');
        }
      });
    } else {
      // Create new quote
      this.quoteService.createQuote(createQuoteInput, quoteItems).subscribe({
        next: () => {
          this.loading = false;
          this.toastr.success('Quote created successfully');
          this.router.navigate(['/quotation']);
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error.message || 'Failed to create Quote.');
        }
      });
    }
  }
  
  
  onCancel(): void {
    this.quoteForm.reset();
    this.router.navigate(['/quotation']);
  }

  onRemoveQuoteItem(index: number, quoteItemId: number): void {
    if (quoteItemId) {
      const dialogRef = this.dialog.open(ConfirmDialog);
      dialogRef.afterClosed().subscribe((response) => {
        if (response === true) {
          this.removeItem(quoteItemId, index);
        }
      });
    } else {
      console.error('Item ID is null or undefined');
      this.items.removeAt(index);
    }
  }

  private removeItem(quoteItemId: number, index: number): void {
    this.quoteService.removeQuoteItemById(quoteItemId).subscribe({
      next: (response) => {
        this.toastr.success('Quote item removed successfully.');
        this.quoteItemLength = this.quoteItemLength - 1;
        this.quoteData = {
          ...this.quoteData,
          quoteItems: [
            ...this.quoteData.quoteItems.slice(0, index),
            ...this.quoteData.quoteItems.slice(index + 1),
          ],
        };
        this.updateCalculatedItems();
        console.log('this.quoteData',this.quoteData);
        
      },
      error: (error) => {
        this.toastr.error(error.message || 'Failed to remove quote item.');
      },
    });
  }

  onRemoveNewlyAddedItems(index: number): void {
    this.items.removeAt(index);
  }

  generateQuoteNumber(): void {
    const randomSuffix = Math.floor(1000 + Math.random() * 9000);
    const invoiceNo = `QT-${randomSuffix}`;
    this.quoteForm.patchValue({ invoiceNo });
  }

  preferenceCode(search: string = '') {
    this.preferenceService.fetchPreferenceCodes(search, 'Quote').subscribe({
      next: (response) => {
        response.forEach((prefix: any) => {
          this.quoteNumber = prefix?.sequenceCode;
        });
        // const randomSuffix = Math.floor(1000 + Math.random() * 9000);
        // this.prefix = `${this.quoteNumber + randomSuffix}`;
        this.quoteForm.patchValue({ quoteCode: this.quoteNumber });
      },
      error: (error) => {
        console.error(error, 'Error');
      },
    });
  }

  disableBeforeQuoteDate = (date: Date | null): boolean => {
    const quoteDate = this.quoteForm.get('quoteDate')?.value;
    if (!quoteDate || !date) {
      return true;
    }
    return date >= new Date(quoteDate);
  };

  private fetchPartners(search: string = '') {
    this.customerService.fetchCustomers(search).subscribe({
      next: (partners: any) => {
        this.partnersData = partners;
        // .filter((data: any) => data.partnerType === 'Customer')
        // .map((data: any) => ({
        //   id: data.id || '--',
        //   name: data.displayName || '--',
        //   addresses: data.addresses || [],
        //   partnerProjects: data.partnerProjects || [],
        //   trnNumber: data.trnNumber || '',
        // }));
        if (this.quoteId) {
          this.loadQuoteData(); // Ensure loadQuoteData is called after partnersData is ready
        }
        this.billingAddressList = partners
          .flatMap((partner: any) => partner.addresses || [])
          .filter((address: any) => address.addressType === 'BILLING');
        this.shippingAddressList = partners
          .flatMap((partner: any) => partner.addresses || [])
          .filter((address: any) => address.addressType === 'SHIPPING');
      },
      error: (error) => console.error(error),
    });
  }

  private listBranches(search: string = '') {
    this.employeeService.getBranches().subscribe({
      next: (branches) => {
        this.branchData = branches
          .filter((data: any) => data.branchName !== 'All')
          .map((data: any) => ({
            id: data.id || '--',
            branchName: data.branchName || '--',
          }));
        // this.populateBranches();
      },
      error: (error) => console.error(error),
    });
  }

  private fetchItems(search: string = '', filter: any = {}) {
    const updatedFilter = {
      ...filter,
      isSalesActive: true,
    };

    // this.itemService.fetchItems(search, updatedFilter).subscribe({
    //   next: (items) => {
    //     this.itemData = items;
    //     this.filteredItemData = items;
    //   },
    //   error: (error) => console.error(error),
    // });
  }

  openCreateClientDialog() {
    // const dialogRef = this.dialog.open(CreateClientDialog, {
    //   disableClose: true,
    // });
    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result && result.newCustomer) {
    //     this.partnersData.push(result.newCustomer);
    //     this.quoteForm.patchValue({ partnerId: result.newCustomer.id });
    //   }
    //   this.fetchPartners();
    // });
  }

  openBillingAddressDialog(type: any) {
    // const selectedClientId = this.quoteForm.get('partnerId')?.value;
    // this.dialog.open(BillingAddressDialog, {
    //   width: '400px',
    //   data: {
    //     clientId: selectedClientId,
    //     type,
    //   },
    // });
  }

  openShippingAddressDialog(type: any) {
    // const selectedClientId = this.quoteForm.get('partnerId')?.value;
    // this.dialog.open(ShippingAddressDialog, {
    //   width: '400px',
    //   data: {
    //     clientId: selectedClientId,
    //     type,
    //   },
    // });
  }

  openSelectBillingAddressDialog() {
    // const selectedCustomerId = this.selectedCustomerId;
    // const type = 'BILLING';
    // const dialogRef = this.dialog.open(ListBillingAddressDialog, {
    //   data: {
    //     selectedCustomerId,
    //     type,
    //   },
    // });
    // dialogRef.afterClosed().subscribe((address) => {
    //   if (address) {
    //     this.selectedBillingAddress = address;
    //     this.quoteForm.patchValue({ billingAddressId: address.id });
    //   }
    // });
  }

  openSelectShippingAddressDialog() {
    const selectedCustomerId = this.selectedCustomerId;
    const type = 'SHIPPING';

    // const dialogRef = this.dialog.open(ListShippingAddressDialog, {
    //   data: {
    //     selectedCustomerId,
    //     type,
    //   },
    // });
    // dialogRef.afterClosed().subscribe((address) => {
    //   if (address) {
    //     this.selectedShippingAddress = address;
    //     this.quoteForm.patchValue({ shippingAddressId: address.id });
    //   }
    // });
  }

  private updateCalculatedItems() {
    this.calculatedItems = this.quoteData?.quoteItems?.map((item: any) => {
      console.log('item',item);
      
      const quantity = Number(item.quantity);
      const rate = Number(item.rate);
      const amount = Number(item.amount);
      const grossAmount = this.calculateGrossAmount(rate, quantity);
      let eta: any = 0;

     item.quoteServiceTasks?.forEach((task: any) => {
      eta += Number(task.estimatedTime) || 0;
    });
      return {
        ...item,
        quantity,
        rate,
        amount,
        eta,
        total: grossAmount,
      };
    });

  }

  calculateGrossAmount(rate: number, quantity: number): number {
    return rate * quantity;
  }

  calculateNetAmount(grossAmount: number, discount: number): number {
    return grossAmount - discount;
  }
}
